"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable no-console */
console.warn('`svcCard` is deprecated and will be removed in a future release! Please migrate to equivalent `starbucksCard`');
var _default = exports["default"] = 'M13.9 5.75H2.811c-.558 0-1.011.446-1.011 1v10.5c0 .553.454 1 1.011 1h18.378c.558 0 1.011-.446 1.011-1V6.75c0-.553-.454-1-1.011-1H14.9v10.5c0 .276-.232.5-.5.5a.503.503 0 0 1-.5-.5V5.75zm-13.1 1c0-1.104.906-2 2.027-2h18.346c1.12 0 2.027.896 2.027 2v10.5c0 1.104-.906 2-2.027 2H2.827c-1.12 0-2.027-.896-2.027-2V6.75zm17.75 4.9a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zm0-1a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z';
/* eslint-enable no-console */